<template>
	<div class="container">
		<!-- 悬浮分享按钮 -->
		<div class="share-fixed-btn" @click="showShareDialog">
			<el-button type="primary" icon="el-icon-share" circle class="share-icon-btn"></el-button>
		</div>

		<div class="content">
			<!-- 面包屑导航 -->
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/insure/index' }">保险产品</el-breadcrumb-item>
					<el-breadcrumb-item>产品详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<!-- 产品头部信息 -->
			<div class="box box-header">
				<div class="box-header-left">
					<el-image fit="cover" :src="$img(data.main_image)"/>
				</div>
				<div class="box-header-right">
					<div class="box-title">{{ data.name }}</div>
					
					<div class="introd-list">
						<div class="introd-item" v-for="(explain, explainIndex) in data.explain" :key="explainIndex">
							<div class="introd-title">
								<el-image :src="require('@/../static/icon/shield.png')" />
								<div>{{ explain.name }}</div>
							</div>
							<div class="introd-content">{{ explain.content }}</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 保障计划 -->
			<div class="box">
				<div class="box-title">保障计划</div>

				<!-- 保障计划选项 -->
				<div class="plan-list">
					<div v-for="(item, index) in data.specs" 
						:key="index"
						:class="['plan-item', { 'on': specsIndex === index }]"
						@click="changeSpecs(index)">
						{{ item.name }}
					</div>
				</div>
				
				<!-- 保障期限 -->
				<div class="time-title">保障期限</div>
				
				<div class="time-list" v-if="currentSpecs && currentSpecs.price_items">
					<div v-for="(item, index) in currentSpecs.price_items" 
						:key="index"
						:class="['time-item', { 'on': timeIndex === index }]"
						@click="changeTime(index)">
						{{ getTimeRangeText(item) }}
					</div>
				</div>

				<!-- 基本信息 -->
				<div class="basic border">
					<div class="basic-item">
						<div class="basic-title">承保公司</div>
						<div class="basic-content">{{ data.insurer_name }}</div>
					</div>
					<div class="basic-item" v-if="currentSpecs">
						<div class="basic-title">保障年龄</div>
						<div class="basic-content">
							{{ currentSpecs.insured_start_age }}—{{ currentSpecs.insured_end_age }}周岁
						</div>
					</div>
				</div>

				<!-- 保障计划详情 -->
				<div class="collapse" v-if="currentSpecs && currentSpecs.coverage_plan">
					<div class="collapse-item" v-for="(item, index) in currentSpecs.coverage_plan" :key="index">
						<div class="collapse-item-header">
							<div class="collapse-title">{{ item.name }}</div>
							<div class="collapse-value" @click="toggleCoveragePlan(index)">
								{{ item.amount }} 
								<i :class="item.show ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							</div>
						</div>
						<div v-if="item.show" class="collapse-item-content">{{ item.content }}</div>
					</div>
				</div>
			</div>

			<!-- 承保范围 -->
			<div class="box" v-if="hasCoverageOrExclusion">
				<div class="box-title">承保范围</div>

				<div class="detail border" v-if="currentSpecs && currentSpecs.coverage_items">
					<div class="detail-title">承保项目</div>
					<div class="detail-content">{{ currentSpecs.coverage_items }}</div>
				</div>

				<div class="detail" v-if="currentSpecs && currentSpecs.exclusion_items">
					<div class="detail-title">不承保项目</div>
					<div class="detail-content">{{ currentSpecs.exclusion_items }}</div>
				</div>
			</div>

			<!-- 产品文档 -->
			<div class="box">
				<div class="box-title">产品报价单、保险条款与特别约定</div>
				<div class="agreement-list">
					<div class="agreement-item">产品报价单</div>
					<div class="agreement-item">保险条款</div>
					<div class="agreement-item">特别约定</div>
				</div>
				<div class="box-title">单证模板</div>
				<div class="agreement-list">
					<div class="agreement-item">电子保单模板</div>
					<div class="agreement-item">保险条款</div>
				</div>
			</div>

			<!-- 投保提示 -->
			<div class="box" v-if="currentSpecs && currentSpecs.detail">
				<div class="box-title">投保提示</div>
				<div class="richtext" v-html="currentSpecs.detail"></div>
			</div>
		</div>

		<!-- 投保确认弹窗 -->
		<el-dialog top="40vh" title="提示" :visible.sync="dialogVisible" width="30%">
			<div class="dialog">
				{{ $getter('setting').value14 }}
				投保前请仔细阅读 <span>客户告知书</span>。
				点击"确认开始投保"后，您在销售页面的操作将被依法记录和保存。
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button class="footer-btn" type="primary" @click="handleConfirm">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 分享弹窗 -->
		<el-dialog 
			title="复制链接" 
			:visible.sync="shareDialogVisible" 
			width="480px"
			:close-on-click-modal="false">
			
			<div class="simple-share-container">
				<div class="link-copy-section">
					<div class="section-title">
						<i class="el-icon-link"></i>
						<span>产品链接</span>
					</div>
					<div class="link-input-wrapper">
						<el-input 
							ref="shareLinkInput"
							v-model="currentUrl"
							readonly
							class="share-link-input">
							<template slot="append">
								<el-button 
									type="primary" 
									@click="copyLink"
									:loading="copyLoading"
									:class="['copy-btn', { 'success': copySuccess }]">
									{{ copySuccess ? '已复制' : '复制' }}
								</el-button>
							</template>
						</el-input>
					</div>
					<div class="copy-tips">
						<i class="el-icon-info"></i>
						<span>复制上面的链接分享给朋友</span>
					</div>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="shareDialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>

		<!-- 底部栏 -->
		<div class="bottom">
			<div class="bottom-left" @click="$navto('/insure/claimsGuide')">
				<el-image :src="require('@/../static/insure/compensate.png')" />
				<div>理赔指南</div>
			</div>
			
			<div class="bottom-right">
				<div class="amount" v-if="currentPriceItem">
					￥{{ currentPriceItem.price }}<span>元/ 起</span>
				</div>
				<div class="bottom-btn" @click="dialogVisible = true">立即投保</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				shareDialogVisible: false,
				copyLoading: false,
				copySuccess: false,
				data: {},
				specsIndex: 0,
				timeIndex: 0,
				insured_days: 1,
				currentUrl: window.location.href,
			}
		},

		computed: {
			// 当前选中的规格
			currentSpecs() {
				return this.data.specs && this.data.specs[this.specsIndex];
			},

			// 当前选中的价格项
			currentPriceItem() {
				return this.currentSpecs && 
				       this.currentSpecs.price_items && 
				       this.currentSpecs.price_items[this.timeIndex];
			},

			// 是否有承保范围或不承保项目
			hasCoverageOrExclusion() {
				return (this.currentSpecs && this.currentSpecs.coverage_items) || 
				       (this.currentSpecs && this.currentSpecs.exclusion_items);
			},

			// 是否有投保提示
			hasInsuranceTips() {
				return this.currentSpecs && this.currentSpecs.detail;
			}
		},

		watch: {
			shareDialogVisible(val) {
				if (!val) {
					this.copySuccess = false;
				}
			}
		},

		mounted() {
			this.loadProductData(this.$route.query.id);
		},

		methods: {
			// ==================== 数据处理方法 ====================
			/**
			 * 获取产品数据
			 */
			loadProductData(id) {
				if (!id) return;
				
				this.$load();
				this.$get('app-goods/' + id).then(res => {
					this.data = res.data;
				}).catch(err => {
					this.$message.error(err);
				})
			},

			/**
			 * 获取时间段文本
			 */
			getTimeRangeText(item) {
				if (item.max_days === 0) {
					return `${item.min_days}天及以上`;
				} else if (item.min_days === item.max_days) {
					return `${item.min_days}天`;
				} else {
					return `${item.min_days}-${item.max_days}天`;
				}
			},

			// ==================== 交互处理方法 ====================
			/**
			 * 切换保障计划
			 */
			changeSpecs(index) {
				this.specsIndex = index;
				this.timeIndex = 0; // 重置保障期限选择
			},

			/**
			 * 切换保障期限
			 */
			changeTime(index) {
				this.timeIndex = index;
			},

			/**
			 * 切换保障计划详情展开/收起
			 */
			toggleCoveragePlan(index) {
				if (!this.currentSpecs || !this.currentSpecs.coverage_plan || !this.currentSpecs.coverage_plan[index]) return;
				
				const item = this.currentSpecs.coverage_plan[index];
				item.show = !item.show;
				this.$forceUpdate();
			},

			// ==================== 投保相关方法 ====================
			/**
			 * 确认投保
			 */
			handleConfirm() {
				const userInfo = this.$getter('UserInfo');
				
				if (userInfo && userInfo.id) {
					this.dialogVisible = false;
					this.navigateToCreateOrder();
				} else {
					this.dialogVisible = false;
					this.showLoginRequired();
				}
			},

			/**
			 * 跳转到创建订单页面
			 */
			navigateToCreateOrder() {
				const queryParams = {
					id: this.data.id,
					insured_days: this.insured_days,
					specsIndex: this.specsIndex
				};
				
				this.$router.push({
					path: '/insure/createOrder',
					query: queryParams
				});
			},

			/**
			 * 显示登录提示
			 */
			showLoginRequired() {
				this.$warning('请先登录后进行投保');
				this.$vuex('loginVisible', true, true);
			},

			// ==================== 分享相关方法 ====================
			/**
			 * 显示分享弹窗
			 */
			showShareDialog() {
				this.shareDialogVisible = true;
				this.copySuccess = false;
				this.copyLoading = false;
			},

			/**
			 * 复制链接
			 */
			copyLink() {
				this.copyLoading = true;
				
				// 创建临时输入框
				const tempInput = document.createElement('input');
				tempInput.value = this.currentUrl;
				tempInput.style.position = 'absolute';
				tempInput.style.left = '-9999px';
				document.body.appendChild(tempInput);
				tempInput.select();
				tempInput.setSelectionRange(0, 99999);
				
				try {
					// 尝试使用传统复制方法
					const successful = document.execCommand('copy');
					if (successful) {
						this.handleCopySuccess();
					} else {
						// 回退到其他方法
						this.fallbackCopyMethod();
					}
				} catch (err) {
					// 如果传统方法失败，尝试其他方法
					this.fallbackCopyMethod();
				} finally {
					document.body.removeChild(tempInput);
					this.copyLoading = false;
				}
			},

			/**
			 * 处理复制成功
			 */
			handleCopySuccess() {
				this.copySuccess = true;
				this.$message.success({
					message: '链接已复制到剪贴板',
					duration: 2000,
					showClose: true
				});
				
				setTimeout(() => {
					this.copySuccess = false;
				}, 2000);
			},

			/**
			 * 备用的复制方法
			 */
			fallbackCopyMethod() {
				// 尝试使用 Clipboard API
				if (navigator.clipboard && window.isSecureContext) {
					navigator.clipboard.writeText(this.currentUrl)
						.then(() => {
							this.handleCopySuccess();
						})
						.catch(() => {
							this.showManualCopyPrompt();
						});
				} else {
					this.showManualCopyPrompt();
				}
			},

			/**
			 * 显示手动复制提示
			 */
			showManualCopyPrompt() {
				this.$alert(`请手动复制链接：\n\n${this.currentUrl}`, '复制链接', {
					confirmButtonText: '好的',
					callback: () => {
						this.copySuccess = false;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	/* 样式代码完全不变，与原代码完全一致 */
	.container {
		width: 100%;
		background-color: #F7F7F7;
		padding-bottom: 200px;
		position: relative;

		/* 笔记本屏幕适配 */
		@media (min-width: 1024px) and (max-width: 1440px) {
			padding-bottom: 180px;
		}

		/* 悬浮分享按钮 */
		.share-fixed-btn {
			position: fixed;
			right: 30px;
			top: 120px;
			z-index: 999;
			
			.share-icon-btn {
				width: 50px;
				height: 50px;
				font-size: 20px;
				box-shadow: 0 4px 12px rgba(34, 128, 253, 0.3);
				transition: all 0.3s ease;
				background: linear-gradient(135deg, #2280FD, #1a6fd8);
				border: none;
				
				&:hover {
					transform: translateY(-3px);
					box-shadow: 0 6px 16px rgba(34, 128, 253, 0.4);
					background: linear-gradient(135deg, #1a6fd8, #2280FD);
				}
				
				&:active {
					transform: translateY(-1px);
				}

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					width: 45px;
					height: 45px;
					font-size: 18px;
				}
			}
		}

		/* 简化分享弹窗样式 */
		.simple-share-container {
			padding: 20px 0;
			
			.link-copy-section {
				.section-title {
					display: flex;
					align-items: center;
					margin-bottom: 15px;
					font-size: 16px;
					font-weight: 600;
					color: #333;
					
					i {
						color: #2280FD;
						margin-right: 8px;
						font-size: 18px;
					}

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 15px;
						
						i {
							font-size: 17px;
						}
					}
				}
				
				.link-input-wrapper {
					margin-bottom: 15px;
					
					.share-link-input {
						::v-deep .el-input-group__append {
							background-color: #2280FD;
							border-color: #2280FD;
							
							.copy-btn {
								color: white;
								background: transparent;
								border: none;
								font-weight: 500;
								padding: 0 25px;
								transition: all 0.3s ease;

								/* 笔记本屏幕适配 */
								@media (min-width: 1024px) and (max-width: 1440px) {
									padding: 0 20px;
									font-size: 14px;
								}
								
								&:hover {
									background: rgba(255, 255, 255, 0.1);
								}
								
								&:active {
									transform: scale(0.98);
								}
								
								&.success {
									background-color: #67c23a;
									border-color: #67c23a;
								}
							}
						}
						
						::v-deep .el-input__inner {
							background-color: #f8f9fa;
							border-color: #e4e7ed;
							color: #333;
							font-size: 14px;
							padding: 10px 15px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 13px;
								padding: 9px 14px;
							}
							
							&:focus {
								border-color: #2280FD;
								box-shadow: 0 0 0 2px rgba(34, 128, 253, 0.1);
							}
						}
					}
				}
				
				.copy-tips {
					display: flex;
					align-items: center;
					gap: 8px;
					background-color: #f0f7ff;
					border-radius: 8px;
					padding: 12px 15px;
					
					i {
						color: #2280FD;
						font-size: 16px;
						flex-shrink: 0;
					}
					
					span {
						font-size: 14px;
						color: #666;
						line-height: 1.4;
					}

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						padding: 10px 12px;
						
						i {
							font-size: 15px;
						}
						
						span {
							font-size: 13px;
						}
					}
				}
			}
		}

		/* 笔记本屏幕适配 */
		@media (min-width: 1024px) and (max-width: 1440px) {
			.share-fixed-btn {
				right: 20px;
				top: 100px;
			}
		}

		.banner {
			width: 100%;
		}

		.content {
			margin: 20px auto 40px;
			width: 68%;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 85%;
				margin: 15px auto 30px;
			}

			.box-header {
				display: flex;
				align-items: flex-start; /* 顶部对齐 */

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					/* 保持水平布局，只调整尺寸 */
				}

				.box-header-left {
					flex-shrink: 0; /* 防止图片被压缩 */

					.el-image {
						width: 300px;
						height: 360px;
						border-radius: 10px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 280px; /* 稍微缩小，但保持水平布局 */
							height: 340px;
						}
					}
				}

				.box-header-right {
					margin-left: 20px;
					flex: 1; /* 占据剩余空间 */

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-left: 15px;
					}
				}
			}

			.box {
				background-color: #fff;
				border-radius: 10px;
				padding: 20px;
				margin-top: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 18px;
					margin-top: 18px;
					border-radius: 8px;
				}

				.box-title {
					color: #333333;
					font-size: 20px;
					font-weight: bold;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 18px;
					}
				}
				
				.time-title {
					color: #666666;
					font-size: 16px;
					margin-top: 20px;
					padding-top: 15px;
					border-top: 1px solid #d6d6d6;
					
					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 15px;
					}
				}

				.introd-list {
					.introd-item {
						margin-top: 25px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							margin-top: 20px;
						}

						.introd-title {
							display: flex;
							align-items: center;
							gap: 5px;

							.el-image {
								width: 18px;
								height: 18px;

								/* 笔记本屏幕适配 */
								@media (min-width: 1024px) and (max-width: 1440px) {
									width: 16px;
									height: 16px;
								}
							}

							div {
								color: #333333;
								font-size: 16px;

								/* 笔记本屏幕适配 */
								@media (min-width: 1024px) and (max-width: 1440px) {
									font-size: 15px;
								}
							}
						}

						.introd-content {
							margin-top: 6px;
							margin-left: 23px;
							color: #666666;
							font-size: 14px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 13px;
								margin-top: 5px;
								margin-left: 21px;
							}
						}
					}
				}

				.plan-list {
					margin-top: 15px;
					width: 100%;
					gap: 15px;
					display: flex;
					flex-wrap: wrap;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-top: 10px;
						gap: 12px;
					}

					.plan-item {
						border-radius: 6px;
						width: 120px;
						line-height: 40px;
						text-align: center;
						border: 1px solid #CCCCCC;
						background-color: #fff;
						color: #999999;
						font-size: 16px;
						cursor: pointer;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 110px;
							line-height: 36px;
							font-size: 15px;
						}
					}

					.on {
						background-color: #2280FD;
						border: 1px solid #2280FD;
						color: #fff;
					}
				}
				
				.time-list {
					margin-top: 10px;
					width: 100%;
					gap: 15px;
					display: flex;
					flex-wrap: wrap;
					
					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-top: 10px;
						gap: 12px;
					}
					
					.time-item {
						border-radius: 6px;
						padding: 4px 20px;
						text-align: center;
						border: 1px solid #CCCCCC;
						background-color: #fff;
						color: #999999;
						font-size: 14px;
						cursor: pointer;
					}
					
					.on {
						background-color: #2280FD;
						border: 1px solid #2280FD;
						color: #fff;
					}
				}

				.basic {
					padding-bottom: 20px;
					border-bottom: 1px solid #EEEEEE;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						padding-bottom: 18px;
					}

					.basic-item {
						margin-top: 15px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #666666;
						font-size: 16px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							margin-top: 12px;
							font-size: 15px;
						}

						.basic-title {}

						.basic-content {
							cursor: pointer;
						}
					}
				}

				.collapse {
					.collapse-item {
						margin-top: 15px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							margin-top: 12px;
						}

						.collapse-item-header {
							display: flex;
							justify-content: space-between;
							align-items: center;
							color: #666666;
							font-size: 16px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 15px;
							}

							.collapse-value {
								cursor: pointer;
							}
						}

						.collapse-item-content {
							margin-top: 5px;
							color: #333333;
							font-size: 16px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 15px;
								margin-top: 4px;
							}
						}
					}
				}

				.collapse-more {
					text-align: center;
					margin-top: 10px;
					cursor: pointer;
					font-size: 16px;
					color: #999999;
				}

				.detail {
					margin-top: 15px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-top: 12px;
					}

					.detail-title {
						color: #333333;
						font-size: 16px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 15px;
						}
					}

					.detail-content {
						margin-top: 5px;
						font-size: 14px;
						color: #666666;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 13px;
							margin-top: 4px;
						}
					}
				}

				.agreement-list {
					display: flex;
					gap: 15px;
					margin: 20px 0;
					flex-wrap: wrap;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						gap: 12px;
						margin: 18px 0;
					}

					.agreement-item {
						background-color: #F7F7F7;
						font-size: 16px;
						color: #999999;
						text-align: center;
						line-height: 40px;
						border-radius: 6px;
						width: 130px;
						cursor: pointer;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
							width: 120px;
							line-height: 36px;
							font-size: 15px;
						}
					}
				}

				.richtext {
					margin-top: 20px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-top: 18px;
					}
				}
			}
		}

		.border {
			padding-bottom: 20px;
			border-bottom: 1px solid #EEEEEE;
		}

		.dialog {
			color: #333333;
			font-size: 14px;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				font-size: 13px;
			}

			span {
				color: #2280FD;
				cursor: pointer;
			}
		}

		.dialog-footer {
			.footer-btn {
				background-color: #2280FD;
			}
		}

		.bottom {
			position: fixed;
			z-index: 99;
			bottom: 0;
			width: 100%;
			padding: 15px 16%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: #fff;
			border-top: 1px solid #EEEEEE;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				padding: 12px 12%;
			}

			.bottom-left {
				display: flex;
				align-items: center;
				cursor: pointer;
				gap: 5px;

				.el-image {
					width: 30px;
					height: 30px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						width: 28px;
						height: 28px;
					}
				}

				div {
					color: #999999;
					font-size: 18px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 16px;
					}
				}
			}

			.bottom-right {
				display: flex;
				gap: 20px;
				justify-content: center;
				align-items: center;

				.amount {
					color: #FF2B2B;
					font-size: 28px;
					font-weight: bold;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 24px;
					}

					span {
						font-weight: 500;
						font-size: 16px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 14px;
						}
					}
				}

				.bottom-btn {
					background-color: #2280FD;
					color: #fff;
					width: 120px;
					line-height: 40px;
					border-radius: 50px;
					text-align: center;
					cursor: pointer;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						width: 110px;
						line-height: 36px;
						font-size: 15px;
					}
				}
			}
		}
	}
</style>